import * as yup from "yup";

export const userSchema = yup.object({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string(),
  phoneNumber: yup
    .string()
    .required("Phone Number is required")
    .matches(/^\d{0,16}$/, "Phone Number must be up to 16 digits only"),

  username: yup
    .string()
    .email("Email must be a valid email")
    .required("Email is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    ),
});

export const updateUserSchema = yup.object({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string(),
  phoneNumber: yup
    .string()
    .notRequired()
    .test(
      "is-valid-phone",
      "Phone number must be valid (e.g. +919876543210 or 9876543210)",
      (value) => {
        return (
          !value || /^(\+)?[0-9]{7,15}$/.test(value)
        );
      }
    ),


  username: yup
    .string()
    .email("Email must be a valid email")
    .required("Email is required"),
});
